import fraudWarnings from '../config/ml-fraud-warnings.json'

const defaultConfig = {
    warnings: fraudWarnings.warnings // JSON.parse(fraudWarnings).warnings
};
const config = Object.assign({}, defaultConfig);

export default {
    getAllDisclaimers: () => {
        return config.warnings;
    },
    getDisclaimer: (state) => {
        return config.warnings.find((item) => item.state === state) || config.warnings.find((item) => item.state === 'default');
    },
    getDefaultDisclaimer: () => {
        return config.warnings.find((item) => item.state === 'default');
    }
};